<template>
  <div>
    <md-button
      class="md-just-icon md-success md-simple table-action "
      @click.native="triggerEditTemplate"
      v-if="hasAction()"
    >
      <md-tooltip md-direction="top"> {{ $t("common.edit") }} </md-tooltip>
      <md-icon>edit</md-icon>
    </md-button>
    <md-button
      class="md-just-icon md-danger md-simple table-action "
      @click.native="triggerConfirmDelete"
      v-if="hasAction()"
    >
      <md-tooltip md-direction="top">{{ $t("common.delete") }} </md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>

<script>
import Role from "@/constants/Role";
import { getId } from "@/helpers/utils";
import { isDynamicRole } from "@/helpers/role-helper";
import { All } from "@/constants/Permissions";
import { mapGetters } from "vuex";

export default {
  props: ["item"],
  data() {
    return {
      Role
    };
  },
  computed: {
    ...mapGetters("user", ["role", "info"])
  },
  inject: ["editTemplate", "confirmDelete"],
  methods: {
    hasAction() {
      if (
        this.item.creatorId === getId(this.info) ||
        isDynamicRole(this.info, this.role) ||
        this.$can(All.actions, All.subject)
      ) {
        return true;
      }
      return false;
    },
    triggerEditTemplate() {
      this.editTemplate(this.item);
    },
    triggerConfirmDelete() {
      this.confirmDelete(this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
